(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-norea-gallery]:not([data-norea-initialized])').forEach((gallery) => {
      gallery.dataset.noreaInitialized = 'true';
      const panels = Array.from(gallery.querySelectorAll('[data-norea-media]'));
      const thumbnails = Array.from(gallery.querySelectorAll('[data-norea-thumbnail]'));
      const showMedia = (id) => {
        if (!panels.some((panel) => panel.dataset.mediaId === id)) return;
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.mediaId !== id;
          if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbnails.forEach((thumbnail) => {
          if (thumbnail.dataset.mediaId === id) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      };
      const initial = panels.find((panel) => panel.hasAttribute('data-selected')) || panels[0];
      if (initial) showMedia(initial.dataset.mediaId);
      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        showMedia(thumbnail.dataset.mediaId);
      }));
      gallery.addEventListener('norea:select-media', (event) => showMedia(event.detail.id));
    });
    root.querySelectorAll('[data-norea-size-preview]:not([data-norea-initialized])').forEach((preview) => {
      preview.dataset.noreaInitialized = 'true';
      const panels = Array.from(preview.querySelectorAll('[data-norea-size-panel]'));
      const choices = Array.from(preview.querySelectorAll('[data-norea-size-choice]'));
      const showSize = (choice) => {
        const id = choice.getAttribute('href').slice(1);
        if (!panels.some((panel) => panel.id === id)) return;
        panels.forEach((panel) => { panel.hidden = panel.id !== id; });
        choices.forEach((link) => {
          if (link === choice) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      choices.forEach((choice) => choice.addEventListener('click', (event) => {
        event.preventDefault();
        showSize(choice);
      }));
      if (choices[0]) showSize(choices[0]);
    });
    root.querySelectorAll('[data-norea-product]:not([data-norea-variant-initialized])').forEach((product) => {
      product.dataset.noreaVariantInitialized = 'true';
      const select = product.querySelector('[data-norea-variant]');
      if (!select) return;
      const button = product.querySelector('[data-norea-add]');
      const price = product.querySelector('[data-norea-price]');
      const availability = product.querySelector('[data-norea-availability]');
      const inCart = product.querySelector('[data-norea-in-cart]');
      const updateVariant = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        const alreadyInCart = Number(option.dataset.cartQuantity) > 0;
        if (inCart) inCart.hidden = !alreadyInCart;
        if (availability) availability.textContent = available ? availability.dataset.availableLabel : availability.dataset.unavailableLabel;
        if (button) {
          button.disabled = !available;
          button.querySelector('[data-norea-add-label]').textContent = available ? (alreadyInCart ? button.dataset.repeatLabel : button.dataset.availableLabel) : button.dataset.unavailableLabel;
          button.querySelector('[data-norea-add-price]').textContent = option.dataset.price;
        }
        if (price) {
          const makeLabel = (text) => {
            const label = document.createElement('span');
            label.className = 'norea-visually-hidden';
            label.textContent = text + ' ';
            return label;
          };
          const amount = document.createElement('span');
          amount.textContent = option.dataset.price;
          price.replaceChildren(makeLabel(option.dataset.comparePrice ? price.dataset.saleLabel : price.dataset.regularLabel), amount);
          if (option.dataset.comparePrice) {
            const compare = document.createElement('s');
            compare.textContent = option.dataset.comparePrice;
            price.append(makeLabel(price.dataset.regularLabel), compare);
          }
        }
        if (option.dataset.mediaId) product.querySelector('[data-norea-gallery]')?.dispatchEvent(new CustomEvent('norea:select-media', { detail: { id: option.dataset.mediaId } }));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      };
      select.addEventListener('change', updateVariant);
      updateVariant();
    });
    root.querySelectorAll('[data-norea-filters]:not([data-norea-initialized])').forEach((form) => {
      form.dataset.noreaInitialized = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.classList.add('is-enhanced');
        form.querySelector('[data-norea-sort]')?.addEventListener('change', () => form.requestSubmit());
      }
      const panel = form.querySelector('details');
      panel?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && panel.open) {
          panel.open = false;
          panel.querySelector('summary')?.focus();
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
